// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"SendToPatientForm__wrapper__1NyRi","submitResult":"SendToPatientForm__submitResult__3QOFp","actionWrapper":"SendToPatientForm__actionWrapper__13hE6","wrapper2faOptions":"SendToPatientForm__wrapper2faOptions__2y5rX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SendToPatientForm/SendToPatientForm.css
// module id = 3031
// module chunks = 0